import React from "react";

export const TermsTable = ({ formData, setFormData }) => {
    const terms = formData.contractTerms || [];

    const handleTermCheck = (termId, checked) => {
        setFormData((prev) => ({
            ...prev,
            terms: prev.terms.map((term) => (term.id === termId ? { ...term, checked } : term)),
        }));
    };

    return (
        <>
            <div className="table-container">
                <div className="table-content">
                    <div className="table-wrapper">
                        <div className="table">
                            <table>
                                <colgroup>
                                    <col width="25%" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>
                                            <div className="cell">
                                                <span className="cell-tit">약관 명칭</span>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {terms.length > 0 ? (
                                        terms.map((term, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <div className="cell" data-align="center">
                                                        <span className="cell-desc">{term.name}</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td>
                                                <div className="cell" data-align="center">
                                                    <span className="cell-desc">등록된 약관이 없습니다.</span>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
